import { IKostengruppe } from "./IKostengruppe";

export class Kostengruppe implements IKostengruppe {
    
    kostengruppeID: number;
    kostengruppeKurz: string;
    kostengruppeLang: string;
    kostengruppenartID: number;
    sort: number;
    verwaltungsbereichID: number;

    constructor() {
        this.kostengruppeID = 0;
        this.kostengruppeKurz = "";
        this.kostengruppeLang = "";
        this.kostengruppenartID = 0;
        this.sort = 0;
        this.verwaltungsbereichID = 0;
    }
    
    // constructor(kostengruppeID: number, kostengruppeKurz: string, kostengruppeLang: string, kostengruppenartID: number, sort: number, verwaltungsbereichID: number) {
    //     this.kostengruppeID = kostengruppeID;
    //     this.kostengruppeKurz = kostengruppeKurz;
    //     this.kostengruppeLang = kostengruppeLang;
    //     this.kostengruppenartID = kostengruppenartID;
    //     this.sort = sort;
    //     this.verwaltungsbereichID = verwaltungsbereichID
    // }
}
